<template>
  <div id="pdp-main-container" class="pdp-main-section">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'PDPMainContainer',
};
</script>

<style>
  .pdp-main-section .container {
    font-family: 'Roboto', sans-serif;
    max-width: 1300px;
  }

  .modal-container {
    overflow-y: scroll;
  }

  @media (min-width: 768px) {
    .pdp-main-section .container {
      padding: 0 28px;
    }

    .pdp-main-section .container .ribbon-right {
      left: -13px;
    }
  }

  @media (min-width: 2000px) {
    .pdp-main-section .container {
      max-width: 1500px;
    }
  }

  @media (max-width: 1300px) {
    .pdp-main-section .container {
      max-width: 100vw;
    }
  }

</style>
